import { useEffect } from "react";
import "@/App.css";
import {
    BrowserRouter,
    Routes,
    Route,
    useLocation,
    Outlet,
} from "react-router-dom";
import { Toaster } from "sonner";
import { Header } from "./components/sections/Header";
import { Footer } from "./components/sections/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Contractors from "./pages/Contractors";
import Admin from "./pages/Admin";
import ServiceDetail from "./pages/ServiceDetail";
import ServicesIndex from "./pages/ServicesIndex";
import AreaDetail from "./pages/AreaDetail";
import ServiceAreasIndex from "./pages/ServiceAreasIndex";
import Reviews from "./pages/Reviews";
import Contact from "./pages/Contact";
import Landing from "./pages/Landing";
import Sitemap from "./pages/Sitemap";
import NotFound from "./pages/NotFound";

function ScrollToHash() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash) {
            const id = hash.replace("#", "");
            const el = document.getElementById(id);
            if (el) {
                setTimeout(
                    () => el.scrollIntoView({ behavior: "smooth", block: "start" }),
                    50
                );
                return;
            }
        }
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname, hash]);

    return null;
}

function PublicLayout() {
    return (
        <>
            <Header />
            <Outlet />
            <Footer />
        </>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollToHash />
                <Routes>
                    <Route element={<PublicLayout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/services" element={<ServicesIndex />} />
                        <Route path="/services/:slug" element={<ServiceDetail />} />
                        <Route path="/service-areas" element={<ServiceAreasIndex />} />
                        <Route path="/areas/:slug" element={<AreaDetail />} />
                        <Route path="/reviews" element={<Reviews />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/contractors" element={<Contractors />} />
                        <Route path="/sitemap" element={<Sitemap />} />
                        <Route path="/:slug" element={<Landing />} />
                        <Route path="*" element={<NotFound />} />
                    </Route>
                    <Route path="/admin" element={<Admin />} />
                </Routes>
                <Toaster
                    position="top-right"
                    richColors
                    toastOptions={{
                        style: {
                            fontFamily: "Manrope, system-ui, sans-serif",
                            borderRadius: 0,
                        },
                    }}
                />
            </BrowserRouter>
        </div>
    );
}

export default App;
